import { RecipientContainer, SharingLinkInfo } from 'owa-link-data';
import { trace } from 'owa-trace';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Editor } from 'roosterjs-editor-core';
import { updateComposeLinkViewState } from '../actions/internalActions';
import getComposeLinkViewState from '../selectors/getComposeLinkViewState';
import getLinkText from '../utils/getLinkText';
import { getDisplayName } from '../utils/link/getDisplayName';
import { getFileIcon } from '../utils/link/getFileIcon';
import { Link } from './Link';

export function createSharingLinkView(
    editor: Editor,
    getRecipientWells: () => RecipientContainer[],
    fromAddress: string,
    composeId: string,
    anchorElement: HTMLAnchorElement,
    sharingLinkInfo: SharingLinkInfo,
    sharingLinkInfoHasValidFileName: boolean,
    mimeType: string,
    shouldBeautify: boolean,
    isLinkPreviouslyBeautified: boolean,
    insertFromFilePicker: boolean
) {
    trace.info(
        'createSharingLinkView for id=${anchorElement.id} isLinkPreviouslyBeautified=${isPreviouslyBeautified}`'
    );

    if (!anchorElement && !insertFromFilePicker) {
        trace.error(
            'createSharingLinkView: anchorElement can only be null when inserting from file picker'
        );

        return;
    }

    const shouldShowBeautifiedLink = shouldBeautify || isLinkPreviouslyBeautified;
    const hasValidFileName = sharingLinkInfoHasValidFileName || isLinkPreviouslyBeautified; // Previous beautified link has the file name as the inner text

    // to get the file icon, use the original name that came from the response, as the text filename could have been modified for display
    const fileIcon = getFileIcon(
        isLinkPreviouslyBeautified ? getLinkText(anchorElement) : sharingLinkInfo.fileName,
        shouldShowBeautifiedLink,
        mimeType
    );

    const anchorContainer = document.createElement('span');
    const displayName = getDisplayName(
        anchorElement,
        sharingLinkInfo,
        hasValidFileName,
        shouldBeautify,
        isLinkPreviouslyBeautified
    );

    updateComposeLinkViewState(sharingLinkInfo.linkId, displayName, shouldShowBeautifiedLink);

    ReactDOM.render(
        <Link
            viewState={getComposeLinkViewState(sharingLinkInfo.linkId)}
            getRecipientWells={getRecipientWells}
            fromAddress={fromAddress}
            sharingLink={sharingLinkInfo}
            fileIcon={fileIcon}
            hasValidFileName={hasValidFileName}
            editor={editor}
            originalAnchor={anchorElement}
            composeId={composeId}
            isLinkPreviouslyBeautified={isLinkPreviouslyBeautified}
        />,
        anchorContainer
    );
}
